import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'web-ui-components/lib/organisms/modals';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Container } from 'web-ui-components/lib/global/layout';
import PageNavigation from '../../sharedComponents/PageNavigation/PageNavigation';
import withContent from '../../containers/withContent';
import ewContent from '../utils/content';
import {
	updateOutcomeAcknowledgement,
	setDeclarationStatus,
	setUIError,
	setCurrentWarningPage,
	updateAdditionalPaymentGuidance,
} from '../state/actions';
import {
	getRetrievedOutcome,
	isUiError,
	getDeclarationValue,
	getApiError,
	getCurrentWarningPage,
	isSMEUser,
	isStaticWarning,
	getEffectiveWarningId,
	isApprovalJourney,
	isBatchPayment,
	continueApproverJourney,
} from '../state/selectors';
import { ACK_PAGE, IBActions, PAYMENT_SAFE_PAGE } from '../utils/constants';
import { ContentProps } from '../state/propTypes';
import Acknowledgement from './Acknowledgement';
import SafePayment from './SafePayment';
import { getBrandId } from '../../states/envConfig/selectors';
import { goToPage, pages } from '../../states/page/actions';
import { hasReadTimeOutError } from '../../states/page/selectors';
import { hasApiCallInProgress } from '../../states/api/selectors';
import { isBatch } from '../../states/batch/selectors';

const mapState = (state, props) => ({
	apiError: getApiError(state),
	retrievedOutcome: getRetrievedOutcome(state),
	declarationValue: getDeclarationValue(state),
	uiError: isUiError(state),
	currentPage: getCurrentWarningPage(state),
	brandId: getBrandId(state),
	isSMEUser: isSMEUser(state),
	apiInProgress: hasApiCallInProgress(state),
	isBatch: isBatch(state),
	isStaticWarning: isStaticWarning(state, props.payType),
	effectiveWarningId: getEffectiveWarningId(state, props.payType),
	isApprovalJourney: isApprovalJourney(state),
	continueApproverJourney: continueApproverJourney(state),
	isBatchPaymentForEW: isBatchPayment(state),
	readTimeOutError: hasReadTimeOutError(state),
});

const mapDispatch = (dispatch) => ({
	updateOutcomeAcknowledgement: (payload) => dispatch(updateOutcomeAcknowledgement(payload)),
	setUIError: (value) => dispatch(setUIError(value)),
	setDeclarationStatus: (value) => dispatch(setDeclarationStatus(value)),
	setCurrentWarningPage: (value) => dispatch(setCurrentWarningPage(value)),
	updateAdditionalPaymentGuidance: (data) => dispatch(updateAdditionalPaymentGuidance(data)),
	onCancel: () => dispatch(goToPage(pages.EffectiveWarning.paymentCancelled)),
});

export class Warnings extends Component {
	constructor(props) {
		super(props);
		this.confirmPayment = this.confirmPayment.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.acceptDeclaration = this.acceptDeclaration.bind(this);
		this.showPaymentSafeScreen = this.showPaymentSafeScreen.bind(this);
		this.state = { showLoading: false };
	}

	componentDidMount() {
		const { onAction, isSMEUser } = this.props;

		if (!isSMEUser) onAction(IBActions.ON_REVIEW, { val: false, page: 'ewWarning' });
	}

	handleCancel(event) {
		event.preventDefault();
		const { payType, updateOutcomeAcknowledgement, onCancel } = this.props;
		const payloadRequestData = {
			acknowledgement: false,
			payType,
		};

		updateOutcomeAcknowledgement(payloadRequestData);
		onCancel();
	}

	confirmPayment(event) {
		this.setState({ showLoading: true });

		event.preventDefault();
		const {
			declarationValue,
			setUIError,
			payType,
			updateOutcomeAcknowledgement,
			onContinue,
			isApprovalJourney,
			apiInProgress,
			onAction,
		} = this.props;

		if (apiInProgress) {
			return;
		}

		if (isApprovalJourney) {
			/**
			 * This action call connects with `payments-auth-lib` logic
			 * and `showEWAdditionalGuidanceScreen` UI rendering (weird parent <-> child wrapping).
			 *
			 * With the current Effective Warning implementation, we expect
			 * that user will need to always go through `EWAdditionalGuidanceScreen`
			 * to proceed with the payment.
			 *
			 * `ON_PAYMENT_GUIDANCE, { val: false }` - renders additional "Payment details" table component
			 * `ON_PAYMENT_GUIDANCE, { val: true }` - hides additional "Payment details" table component
			 *
			 * Warnings class logic in short:
			 * ACK_PAGE ->
			 * 	"Continue" button ->
			 * 	`showPaymentSafeScreen` method ->
			 * 	payments-auth-lib - `showEWAdditionalGuidanceScreen` = true ->
			 * PAYMENTS_SAFE_PAGE ->
			 * 	"Proceed with payment" button ->
			 * 	`confirmPayment` method ->
			 * 	payments-auth-lib - `showEWAdditionalGuidanceScreen` = false
			 */
			onAction(IBActions.ON_PAYMENT_GUIDANCE, { val: false });
		}

		if (!isApprovalJourney && !declarationValue) {
			this.setState({ showLoading: false });
			return setUIError(!declarationValue);
		}

		const payloadRequestData = {
			acknowledgement: true,
			payType,
		};

		onContinue();
		updateOutcomeAcknowledgement(payloadRequestData);
		return;
	}

	acceptDeclaration(val) {
		this.props.setDeclarationStatus(val);
	}

	showPaymentSafeScreen(event) {
		event.preventDefault();
		const { updateAdditionalPaymentGuidance, setCurrentWarningPage, payType, isApprovalJourney, onAction } = this.props;

		if (isApprovalJourney) onAction(IBActions.ON_PAYMENT_GUIDANCE, { val: true });

		updateAdditionalPaymentGuidance({ payType });
		setCurrentWarningPage(PAYMENT_SAFE_PAGE);
	}

	render() {
		const { apiError, isApprovalJourney, continueApproverJourney } = this.props;

		// REFACTOR: we shouldn't be rendering this component if there is an api error!
		if (apiError || (isApprovalJourney && continueApproverJourney)) {
			return null;
		}

		const {
			declarationValue,
			uiError,
			currentPage,
			brandId,
			effectiveWarningId,
			isStaticWarning,
			isSMEUser,
			retrievedOutcome,
			content,
			isBatchPaymentForEW,
			apiInProgress,
			readTimeOutError,
		} = this.props;

		const {
			effective_warning_details: { checklist_items: checklistItems, ...restOfAcknowledgementOutome },
			effective_warning_additional_details: { scam_indicators: scamIndicators, ...restOfSafePaymentOutcome },
		} = retrievedOutcome;
		const { acknowledgement, safePayment, cancelPaymentText, continueText, checkMyPayment } = content;

		const primaryButtonText = currentPage === ACK_PAGE ? checkMyPayment : continueText;
		const handlePrimaryButton = currentPage === ACK_PAGE ? this.showPaymentSafeScreen : this.confirmPayment;

		if ((apiInProgress || this.state.showLoading) && !readTimeOutError) {
			return <Loader isOpen />;
		}

		return (
			<div id="warningPage" data-ewId={effectiveWarningId}>
				<Container>
					{currentPage === ACK_PAGE && ( // REFACTOR: these should be separate pages in a layout container
						<Acknowledgement outcome={{ ...restOfAcknowledgementOutome, scamIndicators }} content={acknowledgement} />
					)}
					{currentPage === PAYMENT_SAFE_PAGE && (
						<SafePayment
							outcome={{ ...restOfSafePaymentOutcome, checklistItems }}
							content={safePayment}
							brandId={brandId}
							isSMEUser={isSMEUser}
							isStaticWarning={isStaticWarning || isBatchPaymentForEW}
							uiError={uiError}
							acceptDeclaration={this.acceptDeclaration}
							declarationValue={declarationValue}
							isApprovalJourney={isApprovalJourney}
						/>
					)}
					<PageNavigation
						handleContinue={handlePrimaryButton}
						handleBack={this.handleCancel}
						showContinue
						enableContinue
						enableBack
						showBack
						secondaryButtonText={cancelPaymentText}
						continueButtonText={primaryButtonText}
						showLoading={this.state.showLoading}
					/>
				</Container>
			</div>
		);
	}
}

Warnings.propTypes = {
	retrievedOutcome: PropTypes.shape({
		warnings: PropTypes.arrayOf(PropTypes.shape({})),
		header: PropTypes.shape({}),
		bullet_points: PropTypes.arrayOf(PropTypes.shape({})),
	}),
	updateOutcomeAcknowledgement: PropTypes.func.isRequired,
	content: PropTypes.shape(ContentProps).isRequired,
	declarationValue: PropTypes.bool.isRequired,
	setUIError: PropTypes.func.isRequired,
	setDeclarationStatus: PropTypes.func.isRequired,
	uiError: PropTypes.bool,
	apiError: PropTypes.bool.isRequired,
	brandId: PropTypes.string.isRequired,
	onContinue: PropTypes.func.isRequired,
	setCurrentWarningPage: PropTypes.func.isRequired,
	onCancel: PropTypes.func,
	currentPage: PropTypes.string.isRequired,
	isSMEUser: PropTypes.bool,
	onAction: PropTypes.func,
	updateAdditionalPaymentGuidance: PropTypes.func,
	isStaticWarning: PropTypes.bool,
	payType: PropTypes.string,
	effectiveWarningId: PropTypes.string,
	isApprovalJourney: PropTypes.bool,
	continueApproverJourney: PropTypes.bool,
	readTimeOutError: PropTypes.bool,
};

export default compose(connect(mapState, mapDispatch), withContent({ content: ewContent }))(Warnings);
